<script setup>
import CaseStudiesContent from "./components/CaseStudiesContent.vue";
</script>

<template>
  <CaseStudiesContent />
</template>
